import { NicheListWidgetAlive } from "components/widgets/NicheListWidgetAlive";
import { routes } from "@/common/utils/routes";
import React from "react";
import { useTrendingNiches } from "@/common/hooks/useTrendingNiches";

interface ITrendingNichesProps {
  listSize?: number;
}

export const TrendingNiches: React.FC<ITrendingNichesProps> = (props) => {
  const { trendingNiches } = useTrendingNiches();

  return (
    <NicheListWidgetAlive
      className="trendingNiches"
      title="Trending Niches"
      link={routes.niches()}
      niches={trendingNiches}
      page={1}
      listSize={props.listSize}
    />
  );
};
